import { motion } from "framer-motion";

export function Section({ children, className = "", id, dataTestid }) {
  return (
    <section
      id={id}
      data-testid={dataTestid}
      className={`relative px-6 lg:px-10 py-20 md:py-28 ${className}`}
    >
      <div className="max-w-[1400px] mx-auto">{children}</div>
    </section>
  );
}

export function Eyebrow({ children, dataTestid }) {
  return (
    <div
      data-testid={dataTestid}
      className="inline-flex items-center gap-2 font-mono text-[10px] uppercase tracking-[0.25em] text-[#ccff00]"
    >
      <span className="h-px w-6 bg-[#ccff00]" />
      {children}
    </div>
  );
}

export function FadeIn({ children, delay = 0, y = 24, className = "" }) {
  return (
    <motion.div
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.6, delay, ease: [0.22, 1, 0.36, 1] }}
      className={className}
    >
      {children}
    </motion.div>
  );
}
